import { render, staticRenderFns } from "./IsoCustomData.vue?vue&type=template&id=4baaecb5&"
import script from "./IsoCustomData.vue?vue&type=script&lang=js&"
export * from "./IsoCustomData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports